import { render, staticRenderFns } from "./ExportRequestsTable.vue?vue&type=template&id=383a3f96&scoped=true"
import script from "./ExportRequestsTable.vue?vue&type=script&lang=js"
export * from "./ExportRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a3f96",
  null
  
)

export default component.exports